export interface UserInitialsSource {
  displayName?: string
  email?: string
}

export function getUserInitials(user: UserInitialsSource | null | undefined): string {
  const displayName = user?.displayName?.trim() ?? ''

  if (displayName.length > 0) {
    const parts = displayName.split(/\s+/).filter(Boolean)

    if (parts.length >= 2) {
      return `${parts[0][0] ?? ''}${parts[parts.length - 1][0] ?? ''}`.toUpperCase()
    }

    if (parts.length === 1) {
      return (parts[0][0] ?? '').toUpperCase()
    }
  }

  const emailFirstLetter = user?.email?.trim().charAt(0)

  if (emailFirstLetter) {
    return emailFirstLetter.toUpperCase()
  }

  return '?'
}
